/**
 * TrainingsEmptyState
 *
 * Empty state when no trainings match filters, or no data.
 * Medplum does not provide a dedicated empty-state component; Mantine Box + Text.
 */

import { Box, Stack, Text } from '@mantine/core';
import { IconClipboardOff } from '@tabler/icons-react';

interface TrainingsEmptyStateProps {
  variant: 'no-trainings' | 'no-results';
  onClearFilters?: () => void;
}

export function TrainingsEmptyState({ variant, onClearFilters }: TrainingsEmptyStateProps): JSX.Element {
  const isNoResults = variant === 'no-results';

  return (
    <Box py="xl" px="md">
      <Stack align="center" gap="sm">
        <IconClipboardOff size={40} stroke={1.2} color="var(--mantine-color-unifyGrey-4)" />
        <Text size="sm" c="dimmed" ta="center">
          {isNoResults
            ? 'No trainings match your filters. Try adjusting filters or clear them.'
            : 'No trainings assigned yet. Required and optional trainings will appear here.'}
        </Text>
        {isNoResults && onClearFilters && (
          <Text
            size="xs"
            c="blue"
            style={{ cursor: 'pointer', textDecoration: 'underline' }}
            onClick={onClearFilters}
          >
            Clear filters
          </Text>
        )}
      </Stack>
    </Box>
  );
}
